// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { CurpProvider } from './context/CurpContext';
import { installGlobalErrorReporting } from './utils/reportError';

installGlobalErrorReporting();

ReactDOM.render(
  <React.StrictMode>
    <CurpProvider>
      <App />
    </CurpProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
